var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 7.33203H5.99984V8.66536H4.6665V7.33203ZM4.6665 9.9987H5.99984V11.332H4.6665V9.9987ZM7.33317 7.33203H8.6665V8.66536H7.33317V7.33203ZM7.33317 9.9987H8.6665V11.332H7.33317V9.9987ZM9.99984 7.33203H11.3332V8.66536H9.99984V7.33203ZM9.99984 9.9987H11.3332V11.332H9.99984V9.9987Z",
    fill: "#A2A2A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 14.6654H12.6667C13.402 14.6654 14 14.0674 14 13.332V3.9987C14 3.26336 13.402 2.66536 12.6667 2.66536H11.3333V1.33203H10V2.66536H6V1.33203H4.66667V2.66536H3.33333C2.598 2.66536 2 3.26336 2 3.9987V13.332C2 14.0674 2.598 14.6654 3.33333 14.6654ZM12.6667 5.33203L12.6673 13.332H3.33333V5.33203H12.6667Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxCalendar);
export default __webpack_public_path__ + "static/media/bx-calendar.432bcced74a5c40ec523bc74728fe96c.svg";
export { ForwardRef as ReactComponent };